<template>
  <!-- Only render the filter when we actually have stops -->
  <FiltersItemContent v-if="airportStops.length">
    <template #title>
      {{ $l('global.simplePhrases.transferAirports') }}
      <span
        v-if="selectedStops.length"
        class="filtersTitle__reset"
        @click="reset"
      >
        {{ $l('showresult.filter.resetTitle') }}
      </span>
    </template>

    <template #content>
      <FiltersList
        id="filter-country"
        :items="countryItems"
        @itemClicked="toggleCountry"
        @exclusiveClicked="exclusiveCountry"
      >
        <template #itemEnd="{ item }">
          <FiltersList
            class="filtersList--inner"
            :items="cityItems(item.country)"
            @itemClicked="toggleCity"
            @exclusiveClicked="exclusiveCity"
          >
            <!-- <template
              #textEnd="{ item }"
            > -->
            <!-- <span class="filtersList--checkboxprice">{{ resultQueryStore.state.response.airportPriceMap.stops[item.value] ? $lc(resultQueryStore.state.response.airportPriceMap.stops[item.value]) : '' }}</span> -->
            <!-- </template> -->
          </FiltersList>
        </template>
      </FiltersList>
    </template>
  </FiltersItemContent>
</template>

<script setup>
import { arrayMergePrimitive, arrayToggleValue } from '@utils/toolbox';
import { useFiltersStore } from './store/filtersStore';
import { useResultQueryStore } from './store/resultQueryStore';

const filters = useFiltersStore();
const resultQueryStore = useResultQueryStore();

const airportStops = computed(() => resultQueryStore.state.response.uniqueAirportStops.map(({ iata }) => iata));

const airportDetails = computed(() => resultQueryStore.state.response.airportDetails);
const selectedStops = computed(() => filters.state.airportStops);
const selectedSet = computed(() => new Set(selectedStops.value));

const airportItems = computed(() =>
	airportStops.value.map(iata => ({
		country: airportDetails.value[iata].country,
		text: airportDetails.value[iata].airport,
		value: iata
	}))
);

const countryItems = computed(() => {
// Group all airport items by country
	const grouped = airportItems.value.reduce((acc, { country, value }) => {
		(acc[country] ||= []).push(value);
		return acc;
	}, {});

	// Transform the map into the structure expected by FiltersList
	return Object.keys(grouped)
		.sort((a, b) => a.localeCompare(b, 'sv'))
		.map((country) => {
			const stops = grouped[country];
			const noneSelected = selectedStops.value.length === 0;
			const isChecked = noneSelected || stops.some(s => !selectedSet.value.has(s));

			return { country, text: country, stops, isChecked };
		});
});

const cityItems = country =>
	airportItems.value
		.filter(item => item.country === country)
		.sort((a, b) => a.text.localeCompare(b.text, 'sv'))
		.map(({ text, value }) => ({
			text,
			value,
			isChecked: selectedStops.value.length === 0 || !selectedSet.value.has(value)
		}));

function update (stops) {
	filters.set({ key: 'airportStops', value: stops });
}

const reset = () => update([]);

function toggleCountry ({ stops, isChecked }) {
	const merged = isChecked
		? arrayMergePrimitive(stops, selectedStops.value)
		: selectedStops.value.filter(s => !stops.includes(s));

	// If nothing changed, treat it as a reset
	update(merged.length === selectedStops.value.length ? [] : merged);
}

const exclusiveCountry = ({ stops }) => update(arrayToggleValue(airportStops.value, stops));
const exclusiveCity = ({ value }) => update(arrayToggleValue(airportStops.value, value));
const toggleCity = ({ value }) => update(arrayToggleValue(selectedStops.value, value));
</script>


<style lang="scss" scoped>
:deep(.hasExclusive .filtersListItem:hover) {
  .filtersListItemText {
    max-width: 5.5rem;
  }
}
</style>
